// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/clock.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/clock'

import { Icon, type IconComponentProps } from '../icon'

export const ClockIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
